import templateUrl from "webforms/formio/formio-submissions.htm";
import controller from "webforms/formio/formio-submissions.controller";

export default {
  bindings: {
    ngModel: "=?",
    formioId: "<?",
    hideHeader: "@",
    layout: "@",
    disableQueryString: "<",
    mode: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
